// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__17d4N","rootCenter":"LoadMoreObserver_rootCenter__3BHYE","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__mPKPY"};